<div *ngIf="processSheet && isDraft !== undefined">
    <div style="align-items: center;" class="flex flex-row justify-between">
      <div style="align-items: center;" class="mt-2 flex flex-row">
        <dx-lookup
          [label]="'entity.processSheet.materialLists' | translate | ucfirst"
          [width]="616"
          [disabled]="!isDraft"
          [gsResource]="boms"
          [(value)]="bomId"
          [backendFilters]="{documentTypeId: processSheet!.documentTypeId}"
          fieldTemplate="copyBom"
          itemTemplate="copyBom"
          displayExpr="name"
          (onSelectionChanged)="onBomChange($event)"
          valueExpr="id">
          <div *dxTemplate="let bom of 'copyBom'">
            <div *ngIf="bom">
              <div style="white-space: normal">
                <div>{{ bom.code }}</div>
                <div>{{ bom.name }}</div>
                <div style="white-space: normal" > {{'entity.bom.version' | translate| ucfirst}}: {{ bom.version }}</div>
              </div>
            </div>
          </div>
        </dx-lookup>
          <dx-button [style.color]="!isDraft ? '#c6c6c6' : null" class="mb-1 m-1" hint="add bom" icon="add" [disabled]="!isDraft"
          (click)="addBom()"/>
          <dx-button class="mb-1 m-1" hint="copy bom" icon="copy"
          [disabled]="!bomId || !isDraft"
          (click)="copyBom()"/>
          <dx-button class="mb-1 m-1" [hint]="'entity.processSheet.links' | translate | ucfirst" icon="bulletlist"
          [disabled]="!bomId"
          (click)="openRevisions()"/>
          <div
          *ngIf="bom"
          class="px-3 py-1 rounded-full text-white text-center mb-3 ml-1"
          [style]="{backgroundColor: stateColors[bom!.stateId]}"
          title="{{ states[bom!.stateId] | ucfirst }}"
        >{{ states[bom!.stateId] | ucfirst }}</div>
      </div>
      <div *ngIf="product"
      >
      {{product.productCode}} - {{product.productName}} | {{product.quantity}} {{product.stockFormatCode}}
      </div>
    </div>
    <div *ngIf="materials" class="h-full flex flex-col">
      <dx-data-grid  [disabledAdd]="!isBomDraft" [disabledDelete]="!isBomDraft" (onCellPrepared)="onCellPrepared($event)" [glamResource]="materials" [createComponent]="addMaterial"  [customParams]="{bomId: bom!.id}">
        <dxo-toolbar>
          <dxi-item location="before">
            <div *dxTemplate>
              <dx-button
                icon="restore_page"
                stylingMode="text"
                [hint]="'entity.processSheet.recalculateProductsMap' | translate"
                [disabled]="!isManinProduct"
                (onClick)="refreshProductsMap()">
              </dx-button>
            </div>
          </dxi-item>
        </dxo-toolbar>
        <dxo-editing [allowUpdating]="isBomDraft" mode="batch"/>
        <dxi-column [caption]="'entity.products' | translate | ucfirst" >
        <dxi-column cellTemplate="productCode" dataField="productCode" [caption]="'common.code' | translate | ucfirst" [allowEditing]="false">
          <div class="hover:underline cursor-pointer" (click)="openProduct(data.data)" *dxTemplate="let data of 'productCode'">
            <span>{{ data.data.productCode }}</span>
          </div>
        </dxi-column>
        <dxi-column cellTemplate="productName" dataField="productName" [caption]="'entity.material' | translate | ucfirst" [allowEditing]="false">
          <div class="hover:underline cursor-pointer" (click)="openProduct(data.data)" *dxTemplate="let data of 'productName'">
            <span>{{ data.data.productName }}</span>
          </div>
        </dxi-column>
        <dxi-column cellTemplate="productCell" editCellTemplate="productCellEdit" dataField="alternativeProducts" [caption]="'entity.processSheet.alternativeProducts' | translate | ucfirst">
          <div *dxTemplate="let item of 'productCell'">
            <ng-container *ngFor="let product of item.data.alternativeProducts; let last = last">
              <div>
                {{ product.code }} - {{ product.name }}
              </div>
              <hr *ngIf="!last" style="margin:4px 0;">
            </ng-container>
          </div>
          <div *dxTemplate="let data of 'productCellEdit'">
            <dx-tag-box
              [gsResource]="productsResource"
              [(value)]="data.value"
              tagTemplate="tagTemplate"
              itemTemplate="itemTpl"
              displayExpr="name"
              valueExpr="id"
              [searchEnabled]="true"
              [searchExpr]="'name'"
              [searchMode]="'contains'"
              [valueChangeEvent]="'blur'"
              (onValueChanged)="saveProducts(data, $event)">
              <div *dxTemplate="let product of 'tagTemplate'">
                <div
                  [ngClass]="{
                    'dx-tag-content': true
                  }"
                >
                <div class="pl-2 text-start" *ngIf="product">
                  <div class="font-bold">
                  <span>{{ product.code }}</span>
                  <span *ngIf="product.eanCode">, {{ product.eanCode }}</span>
                  </div>
                  <div class="text-wrap">{{ product.name }}</div>
                  <div *ngIf="product.technicalFeaturesSummary" class="italic text-wrap">{{ product.technicalFeaturesSummary }}</div>
                  </div>
                  <div
                    class="dx-tag-remove-button"
                  ></div>
                </div>
              </div>
                <div *dxTemplate="let product of 'itemTpl'">
                  <div *ngIf="product">
                    <div class="font-bold">
                      <span>{{ product.code }}</span>
                    </div>
                    <div class="text-wrap">{{ product.name }}</div>
                    <div *ngIf="product.technicalFeaturesSummary" class="text-wrap">{{ product.technicalFeaturesSummary }}</div>
                    <div class="text-wrap">{{ product.familyName }}</div>
                  </div>
                </div>
            </dx-tag-box>
          </div>
        </dxi-column>
          <dxi-column
            dataField="backflush"
            dataType="boolean"
            editCellTemplate="editBackflush"
            [caption]="'entity.processSheet.backflush' | translate | ucfirst"
          >
            <div *dxTemplate="let data of 'editBackflush'">
              <dx-check-box
                [readOnly]="!isBomDraft"
                [value]="data.value"
                (onValueChanged)="updateElement(data, $event)"
              ></dx-check-box>
            </div>
          </dxi-column>
        </dxi-column>
        <dxi-column [caption]="'entity.container.quantity' | translate | ucfirst" >
          <dxi-column
            editCellTemplate="editQuantity"
            dataField="quantity"
            [caption]="'entity.quantity' | translate | ucfirst"
            dataType="number"
          >
            <div *dxTemplate="let data of 'editQuantity'">
              <dx-text-box
                [id]="'formulaDescription_' + data.rowIndex"
                [value]="data.value"
                (mouseenter)="visibleQTooltipIndex = data.rowIndex"
                (mouseleave)="visibleQTooltipIndex = null"
                (onValueChanged)="updateElement(data, $event)"
                class="flex-1"
                [valueChangeEvent]="'change'"
              ></dx-text-box>

              <dx-tooltip
                [visible]="visibleQTooltipIndex === data.rowIndex"
                [target]="'#formulaDescription_' + data.rowIndex"
              >
                {{ 'entity.processSheet.formulaDescription' | translate | ucfirst }}
              </dx-tooltip>
            </div>
          </dxi-column>

          <dxi-column
            [minWidth]="100"
            dataField="waste"
            editCellTemplate="editWaste"
            [caption]="'entity.processSheet.waste' | translate | ucfirst"
            [allowEditing]="true"
          >
            <div *dxTemplate="let data of 'editWaste'">
              <dx-text-box
                [id]="'formulaDescriptionWithMaterialQty_' + data.rowIndex"
                [value]="data.value"
                (mouseenter)="visibleWasteTooltipIndex = data.rowIndex"
                (mouseleave)="visibleWasteTooltipIndex = null"
                (onValueChanged)="updateElement(data, $event)"
                [valueChangeEvent]="'change'"
                class="flex-1"
              ></dx-text-box>

              <dx-tooltip
                [visible]="visibleWasteTooltipIndex === data.rowIndex"
                [target]="'#formulaDescriptionWithMaterialQty_' + data.rowIndex"
              >
                <div *dxTemplate="let d of 'content'">
                  <div style="white-space: pre-line; text-align: left;">
                    {{ 'entity.processSheet.formulaDescriptionWithMaterialQty' | translate }}
                  </div>
                </div>
              </dx-tooltip>
            </div>
          </dxi-column>
        <dxi-column
          dataField="stockFormatName" dataType="string"
          [allowEditing]="false"
          [caption]="'processSheet.format' | translate | ucfirst"
          />
        <dxi-column
          dataField="decimals"
          dataType="number"
          editCellTemplate="editDecimals"
          [caption]="'entity.currency.decimals' | translate | ucfirst"
        >
          <div *dxTemplate="let data of 'editDecimals'">
            <dx-number-box
              [value]="data.value"
              (onValueChanged)="updateElement(data, $event)"
              [valueChangeEvent]="'change'"
            ></dx-number-box>
          </div>
        </dxi-column>
        <dxi-column cellTemplate="operations"
            dataField="operations"
            [caption]="'entity.processSheet.operations'| translate | ucfirst"
            [allowEditing]="false">
            <div *dxTemplate="let data of 'operations'"
                class="h-full w-full hover:cursor-pointer"
                (click)="editOperations(data.data)">
              {{ getOperations(data.data) }}
            </div>
          </dxi-column>
        </dxi-column>
        <dxi-column [caption]="'entity.processSheet.storage'| translate | ucfirst" >
        <dxi-column editCellTemplate="editWarehouse" cellTemplate="warehouseName" dataField="warehouseId" dataType="string" [caption]="'entity.documentPendingBatch.warehouse' | translate | ucfirst">
          <div *dxTemplate="let data of 'editWarehouse'">
            <dx-lookup
              [(value)]="data.data.warehouseId"
              (onValueChanged)="updateWarehouseZoneOrContainer(data, $event)"
              [gsResource]="warehouses"
              displayExpr="name"
              [showClearButton]="true"
              valueExpr="id">
            </dx-lookup>
          </div>
          <div  [ngClass]="{ 'notAvailable': invalidRowIds.has(data.data.id) }" *dxTemplate="let data of 'warehouseName'">
            <span *ngIf="data.data.warehouseName">{{ data.data.warehouseName }}</span>
            <span *ngIf="!data.data.warehouseName" class="text-muted">-</span>
          </div>
        </dxi-column>
        <dxi-column cellTemplate="zoneName" editCellTemplate="editzone" dataField="zoneId" dataType="string" [caption]="'entity.location.zoneId' | translate | ucfirst">
          <div *dxTemplate="let data of 'editzone'">
            <dx-lookup
              [disabled]="!data.data.warehouseId"
              [(value)]="data.data.zoneId"
              [showClearButton]="true"
              (onValueChanged)="updateWarehouseZoneOrContainer(data, $event)"
              [localFilters]="[ zoneFilter(data.data.warehouseId) ]"
              [gsResource]="zones"
              displayExpr="name"
              valueExpr="id">
            </dx-lookup>
          </div>
          <div  [ngClass]="{ 'notAvailable': invalidRowIds.has(data.data.id) }" *dxTemplate="let data of 'zoneName'">
            <span *ngIf="data.data.zoneName">{{ data.data.zoneName }}</span>
            <span *ngIf="!data.data.zoneName" class="text-muted">-</span>
          </div>
        </dxi-column>
        <dxi-column cellTemplate="locationName" editCellTemplate="editlocation" dataField="locationId" dataType="string" [caption]="'entity.assetLocation' | translate | ucfirst">
          <div *dxTemplate="let data of 'editlocation'">
            <dx-lookup
              [(value)]="data.data.locationId"
              [showClearButton]="true"
              (onValueChanged)="updateWarehouseZoneOrContainer(data, $event)"
              [gsResource]="locations"
              fieldTemplate="locationTemplate"
              itemTemplate="locationTemplate"
              [localFilters]="[ locationFilter(data.data.zoneId) ]"
              displayExpr="code"
              valueExpr="id">
              <div *dxTemplate="let item of 'locationTemplate'">
                <div >
                  <div style="white-space: normal;"  >{{ item? item.code + ' - ' + item.description : '' }}</div>
                </div>
              </div>
            </dx-lookup>
          </div>
          <div [ngClass]="{ 'notAvailable': invalidRowIds.has(data.data.id) }" *dxTemplate="let data of 'locationName'">
            <span *ngIf="data.data.locationCode">{{ data.data.locationCode + ' - ' + data.data.locationDescription }}</span>
            <span *ngIf="!data.data.locationCode" class="text-muted">-</span>
          </div>
        </dxi-column>
        <dxi-column cellTemplate="containerTypeName" editCellTemplate="editContainerType" dataField="containerTypeId" dataType="string" [caption]="'common.tabTitle.containerType' | translate | ucfirst">
          <div *dxTemplate="let data of 'editContainerType'">
            <dx-lookup
              [(value)]="data.data.containerTypeId"
              (onValueChanged)="updateWarehouseZoneOrContainer(data, $event)"
              [gsResource]="containerTypes"
              [showClearButton]="true"
              displayExpr="name"
              valueExpr="id">
            </dx-lookup>
          </div>
          <div [ngClass]="{ 'notAvailable': invalidRowIds.has(data.data.id) }" *dxTemplate="let data of 'containerTypeName'">
            <span *ngIf="data.data.containerTypeName">{{ data.data.containerTypeName }}</span>
            <span *ngIf="!data.data.containerTypeName" class="text-muted">-</span>
          </div>
        </dxi-column>
        <dxi-column dataField="containerOccupancy"
        [caption]="'entity.quantity' | translate | ucfirst"
        editCellTemplate="containerOccupancy"
        cellTemplate="occupancy"
        dataType="number"
        >
        <div *dxTemplate="let cellData of 'containerOccupancy'" class="flex" >
          <dx-number-box [value]="cellData.data.containerOccupancy"
            (onValueChanged)="updateWarehouseZoneOrContainer(cellData, $event)"
            [valueChangeEvent]="'change'"
              class="flex-1"
              [min]="0"
              [step]="0.01"
              [showSpinButtons]="false"
          />
        </div>
        <div [ngClass]="{ 'notAvailable': invalidRowIds.has(cellData.data.id) }" *dxTemplate="let cellData of 'occupancy'" class="flex justify-end" >
          {{cellData.data.containerOccupancy}}
         </div>
      </dxi-column>
      <dxi-column cellTemplate="containerProductFormatId" editCellTemplate="containerProductFormatIdedit" dataField="containerProductFormatId" dataType="string" [caption]="'entity.container.format' | translate | ucfirst">
        <div *dxTemplate="let data of 'containerProductFormatIdedit'">
          <dx-lookup
            [(value)]="data.data.containerProductFormatId"
            (onValueChanged)="updateWarehouseZoneOrContainer(data, $event)"
            [gsResource]="formats(data.data.productId)"
            [showClearButton]="true"
            displayExpr="formatCode"
            valueExpr="id">
          </dx-lookup>
        </div>
        <div [ngClass]="{ 'notAvailable': invalidRowIds.has(data.data.id) }" *dxTemplate="let data of 'containerProductFormatId'">
          <span *ngIf="data.data.containerProductFormatCode">{{ data.data.containerProductFormatCode }}</span>
          <span *ngIf="!data.data.containerProductFormatCode" class="text-muted">-</span>
        </div>
      </dxi-column>
      </dxi-column>
      </dx-data-grid>
    </div>
</div>
<gs-popup
  [(visible)]="operationDialog"
  [height]="600"
  [width]="1200"
  [title]="'entity.processSheet.operations' | translate | ucfirst"
  (closed)="closeOperationDialog()"
>
  <form
    gs-popup-form
    *ngIf="bomMaterial && revisionMaterialsResource && operationDialog"
  >
    <dx-text-area
      [label]="'common.tabTitle.product' | translate | ucfirst"
      [value]="bomMaterial.productCode + ' - ' + bomMaterial.productName"
      [readOnly]="true">
    </dx-text-area>

    <dx-number-box
      [label]="'common.quantity' | translate | ucfirst"
      [value]="parseFloat(bomMaterial.quantity)"
      [readOnly]="true">
    </dx-number-box>
  </form>

  <div
    gs-popup-tabs
    *ngIf="bomMaterial && revisionMaterialsResource && operationDialog"
    class="h-full flex flex-col"
  >
    <dx-tab-panel
      class="h-full"
      [deferRendering]="false"
      [showNavButtons]="true"
    >
      <dxi-item style="overflow: hidden" [title]="'entity.processSheet.operations' | translate | ucfirst">
        <div class="h-full flex flex-col">
          <dx-data-grid
            #materialsGrid
            class="flex-1"
            [glamResource]="currentRevisionMaterialsResource"
            keyExpr="id"
            (onInitNewRow)="onOperationMaterialInitNewRow($event)"
            (onSaving)="onSaving($event)"
          >
            <dxi-column
              dataField="bomMaterialId"
              [visible]="false"
              [caption]="'entity.productionOrder.productionOrderOperationId' | translate | ucfirst">
            </dxi-column>

            <dxi-column
              dataField="routingOperationId"
              [caption]="'entity.productionOrder.productionOrderOperationId' | translate | ucfirst">
              <dxo-lookup
                [dataSource]="routingOperations"
                displayExpr="name"
                valueExpr="id">
              </dxo-lookup>
            </dxi-column>

            <dxi-column
              dataField="quantity"
              [caption]="'common.quantity' | translate | ucfirst">
            </dxi-column>
          </dx-data-grid>
        </div>
      </dxi-item>
    </dx-tab-panel>
  </div>
</gs-popup>

<gs-popup
  [(visible)]="revisionsPopupVisible"
  [title]="'entity.processSheet.links' | translate | ucfirst"
  [width]="900"
  [height]="600"
>
  <div gs-popup-tabs class="h-full flex flex-col min-h-0">
    <dx-data-grid
      *ngIf="bomRevisions"
      [glamResource]="bomRevisions"
      [editingLocked]="true"
      [remoteOperations]="{ paging: true }"
      [height]="'100%'"
    >
      <dxi-column cellTemplate="codeCellTpl" dataField="code" [caption]="'entity.processSheet.code' | translate | ucfirst">
        <div (click)="navigateToProcessSheetEditor(item.data)" class="hover:underline cursor-pointer" *dxTemplate="let item of 'codeCellTpl'">
          {{item.data.code}}
        </div>
      </dxi-column>
      <dxi-column cellTemplate="nameCellTpl" dataField="name" [caption]="'entity.processSheet.processSheet' | translate | ucfirst">
        <div (click)="navigateToProcessSheetEditor(item.data)" class="hover:underline cursor-pointer" *dxTemplate="let item of 'nameCellTpl'">
          {{item.data.name}}
        </div>
      </dxi-column>
      <dxi-column cellTemplate="versionNameCellTpl" dataField="versionName" [caption]="'entity.maintenancePlans.version' | translate | ucfirst">
        <div (click)="navigateToProcessSheetEditor(item.data)" class="hover:underline cursor-pointer" *dxTemplate="let item of 'versionNameCellTpl'">
          {{item.data.version}}
        </div>
      </dxi-column>
      <dxi-column cellTemplate="docTypeCellTpl" datafield="documentTypeName" [caption]="'entity.documentType.documentType' | translate | ucfirst">
        <div *dxTemplate="let item of 'docTypeCellTpl'">
          {{ item.data.documentTypeName }}
        </div>
      </dxi-column>
      <dxi-column  cellTemplate="state" dataField="revisionStateId" [caption]="'entity.appointment.stateId' | translate | ucfirst">
        <dxo-lookup [dataSource]="stateTypes" displayExpr="displayName" valueExpr="id"></dxo-lookup>
        <div *dxTemplate="let data of 'state'" class="w-min" style="min-width: 100px; text-align: center;">
          <gs-entity-state-label [resource]="processSheetRs"
                                 [entity]="data.data"
                                 class="w-min">
          </gs-entity-state-label>
        </div>
      </dxi-column>
    </dx-data-grid>
  </div>
</gs-popup>
